import routerOptions0 from "/app/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}